import en from './en/translation.json'
import es from './es/translation.json'

export type Locales = Record<string, { name: string; display: string; translations: object }>

export const supportedLocales: Locales = {
  en: {
    name: 'English',
    display: '**English**',
    translations: en,
  },
  'en-US': {
    name: 'English (United States)',
    display: '**English (United States)**',
    translations: en,
  },
  es: {
    name: 'Spanish',
    display: '**Spanish**',
    translations: es,
  },
  'es-ES': {
    name: 'Spanish (Spain)',
    display: '**Spanish (Spain)**',
    translations: es,
  },
} as const
